<template>
	<div class="dropdown-body">
		<p class="text-primary font-w-600 mb-2">Finanzierungsdetails</p>
		<table class="table table-price-details">
			<tbody>
				<tr>
					<td class="label">
						{{ getPrice(this.$store.state.price.financing.period) }} Monate à
					</td>
					<td class="text-end text-primary rate">
						{{ getPrice(this.$store.state.price.financing.rate) }} €
					</td>
				</tr>
				<tr>
					<td class="label">Fahrzeugpreis</td>
					<td class="text-end">{{ getPrice(car.consumerPriceGross) }} €</td>
				</tr>
				<tr>
					<td class="label">Anzahlung</td>
					<td class="text-end">
						{{ getPrice(this.$store.state.price.financing.deposit) }} €
					</td>
				</tr>
				<tr>
					<td class="label">Nettodarlehensbetrag</td>
					<td class="text-end">{{ getPrice(finance.netLoanAmount) }} €</td>
				</tr>
				<tr>
					<td class="label">Schlussrate</td>
					<td class="text-end">{{ getPrice(finance.finalInstallment) }} €</td>
				</tr>
				<tr>
					<td class="label">Effektiver Jahreszins</td>
					<td class="text-end">{{ finance.annualPercentageRate }} %</td>
				</tr>
				<tr>
					<td class="label">Sollzins (geb.)</td>
					<td class="text-end">{{ finance.nominalInterestRate }} %</td>
				</tr>
			</tbody>
		</table>
		<p class="text-muted font-12 text-wrap">
			{{ getLegalTextFinanceDetails(finance.bank) }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'DetailsDropdownPriceFinancing',
	props: {
		car: {
			type: Object,
			required: true,
		},
		finance: {
			type: Object,
			required: true,
		},
	},
}
</script>

<style lang="scss"></style>
